const ChatClientChannelType = {
  contribution: 1,
  peer: 2,
};

export default ChatClientChannelType;
